import { ComboBox, IDropdownOption, MessageBar, MessageBarType, TextField } from '@fluentui/react';
import React, { useState } from 'react';
import CustomInputIfc from '../../../lib/FormValidator/Form/CustomInputIfc';
import InputField from '../../../lib/FormValidator/Form/InputField';
import MessageCourier from '../../../lib/MessageCourier';
import TimeTaxSupportSystemClient from '../../../system/TimeTaxSupportSystemClient';
import CostPerHourForm from './CostPerHourFormAje';
import useAsyncDataCourier from '../../../common/custom-hooks/useAsyncDataCourier';
import DataDropdown from '../../../lib/FormValidator/Form/DataDropdown';
import { formatStartingSelection } from '../../../common/list-utils';
import { t } from 'i18next';

const currentYear = new Date().getFullYear();

const yearOptions: IDropdownOption[] = Array.from({ length: 6 }, (_, i) => {
  const year = currentYear + 1 - i;
  return {
    key: year.toString(),
    text: String(year),
  };
});

const monthOptions: IDropdownOption[] = [
  { key: "1", text: t('Enero') },
  { key: "2", text: t('Febrero') },
  { key: "3", text: t('Marzo') },
  { key: "4", text: t('Abril') },
  { key: "5", text: t('Mayo') },
  { key: "6", text: t('Junio') },
  { key: "7", text: t('Julio') },
  { key: "8", text: t('Agosto') },
  { key: "9", text: t('Septiembre') },
  { key: "10", text: t('Octubre') },
  { key: "11", text: t('Noviembre') },
  { key: "12", text: t('Diciembre') },
];

interface ICostPerHourDetailViewAjeProps {
  system: TimeTaxSupportSystemClient;
  form: CostPerHourForm | undefined;
  courier: MessageCourier;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  changeBlockUI: (state: boolean) => void;
}

const CostPerHourDetailViewAje = ({ system, form, courier, onBlurCustomInput, changeBlockUI }: ICostPerHourDetailViewAjeProps) => {
  const newForm = form?.getIdInput().getValue() === '';
  const [isOutOfSync, setIsOutOfSync] = useState(false);
  

  const collaborators = useAsyncDataCourier(
      () => system.getCollaboratorSystem().getCollaborators(),
      [system],
      courier
  );

  const collaboratorOptions: IDropdownOption<any>[] = React.useMemo(() => {
    return collaborators
        ? collaborators
            .sort((a, b) => a.getName().localeCompare(b.getName())) // Ordenar colaboradores alfabéticamente por nombre
            .map((col) => {
              return {
                key: col.getId(),
                text: col.getName() + ' ' + col.getLastName(),
                data: col.getId(),
              };
            })
        : [];
  }, [collaborators]);

  const colId = form?.getColidInput().getValue();
  const year = form?.getYearInput().getValue();
  const month = form?.getMonthInput().getValue();

  React.useEffect(() => {
    if (!form) return;

    // Validar que estén completos
    if (!colId || !year || !month) return;

    // Armar periodo YYYY-MM
    const periodo = `${year}-${String(month).padStart(2, '0')}`;
    
    changeBlockUI(true)

    // Llamada a la API
    system
      .getCostPerHourSystem()
      .getHorasCargadarByColId(colId, periodo)
      .then((res) => {
        console.log('Horas esperadas:', res);
        const input = form.getHorasCargadasInput()
        // Si el formulario es para crear
        if( newForm ) {
          input.setValue(res);
          onBlurCustomInput(input)
        } else {
          setIsOutOfSync(res !== input.getValue())
        }
      })
      .catch((err) => {
        console.error(err);
        courier.messageError(t("No se pudo obtener las horas cargadas del colaborador seleccionado"));
      }).finally(() => {
        changeBlockUI(false)
      })


  }, [colId, year, month, form, newForm]);


  return (
      <>
        {form && (
            <div className="">
              <div className="ms-Grid mt-2" dir="ltr">
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm6 form">
                    <div className="ms-Grid-col ms-sm6 form">
                      {!newForm && (
                          <div className="formItem">
                            <TextField label="Id" value={form.getIdInput().getValue()} readOnly={true} />
                          </div>
                      )}
                      <div className="formItem">
                        <ComboBox
                          label="Año"
                          options={yearOptions}
                          selectedKey={form.getYearInput().getValue()}
                          disabled={!newForm}
                          onChange={(_, option) => {
                            if (!option) return;
                            const input = form.getYearInput();
                            input.setValue(option.key);
                            onBlurCustomInput(input)
                          }}
                        />
                      </div>

                      <div className="formItem">
                        <ComboBox
                          label="Mes"
                          options={monthOptions}
                          selectedKey={form.getMonthInput().getValue()}
                          disabled={!newForm}
                          onChange={(_, option) => {
                            if (!option) return;
                            const input = form.getMonthInput();
                            input.setValue(option.key);
                            onBlurCustomInput(input);
                          }}
                        />
                      </div>

                      <div className="formItem">
                        <InputField
                            label="Horas cargadas"
                            input={form.getHorasCargadasInput()}
                            onBlur={onBlurCustomInput}
                            disabled={!newForm}
                            readOnly
                        />
                      </div>
                      <div className="formItem">
                        <InputField
                            label="Costo por hora"
                            input={form.getCostPHInput()}
                            onBlur={onBlurCustomInput}
                        />
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm6 form">
                      <div className="formItem">
                        {/* <InputField
              label="Colaborador Id"
              input={form.getColidInput()}
              onBlur={onBlurCustomInput}
            /> */}

                        {collaboratorOptions && collaboratorOptions.length > 0 ? (
                            <DataDropdown
                                input={form.getColidInput()}
                                label="Colaborador"
                                onBlur={onBlurCustomInput}
                                options={collaboratorOptions}
                                startingSelection={formatStartingSelection(
                                    form.getColidInput().getValue(),
                                    collaboratorOptions
                                )}
                                disabled={!newForm}
                            />
                        ) : null}
                      </div>
                      <div className="formItem">
                        <InputField
                            label="Coeficiente valor agregado"
                            input={form.getCoefInput()}
                            onBlur={onBlurCustomInput}
                        />
                      </div>

                      <div className="formItem">
                        <InputField
                            label="Nombre valor agregado"
                            input={form.getAVNameInput()}
                            onBlur={onBlurCustomInput}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {newForm ? (
                  <div className='mt-2 mb-2 max-width-50' style={{ padding: '0 8px'}}>
                    <MessageBar
                      messageBarType={MessageBarType.info}
                      styles={{ text: { fontSize: 17 } }}
                    >
                      Las horas visualizadas se encuentran actualizadas únicamente hasta el momento en que se realiza el registro de costos y/o se solicita el archivo Excel para su importación, por lo que no incluyen modificaciones posteriores.
                    </MessageBar>
                  </div>
                ) : (
                  <div className='mt-2 mb-2 max-width-50' style={{ padding: '0 8px'}}>
                    <MessageBar
                      messageBarType={MessageBarType.warning}
                      styles={{ text: { fontSize: 17 } }}
                    >
                      Las horas visualizadas reflejan la información disponible al momento de registrar el costo correspondiente al período y ejercicio mencionados, sin considerar modificaciones posteriores.
                    </MessageBar>
                  </div>
                )}
              </div>
            </div>
        )}
      </>
  );
};

export default CostPerHourDetailViewAje;
